/** Keep (or add) `lang` on the current URL so middleware matches the chosen locale. */
export function withLangParam(
    pathname: string,
    currentSearch: string | URLSearchParams,
    locale: string
): string {
    const params =
        typeof currentSearch === 'string'
            ? new URLSearchParams(
                  currentSearch.startsWith('?')
                      ? currentSearch.slice(1)
                      : currentSearch
              )
            : new URLSearchParams(currentSearch.toString());

    params.set('lang', locale);
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
}
